import React from 'react';
import styles from '../../assets/styles/TermsOfService.module.scss';
import { MimaText } from '../../components';
import { useLocation } from 'react-router-dom';

const RefundPolicy = () => {
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const businessName = params.get('businessName');
	const email = params.get('email');

	return (
		<div className={styles.content}>
			<MimaText variant="h2" align="center" color="var(--color-dark)" mb={3}>
				{businessName}
			</MimaText>
			<MimaText variant="h3" align="center" color="var(--color-dark)" mb={3}>
				Our Refund Policy
			</MimaText>
			<div>
				<section className="terms-section">
					<p>
					All payments for service-based fees are final and non-refundable.
					</p>

					<p>
						For product purchases, we offer a 5-day return policy, allowing you to request a return within 5 days of receiving your item.
					</p>

					<p>Shipping fees payments are non-refundable.</p>
					<p>
						To be eligible for a return, your item must be in the same condition
						that you received it, unworn or unused, with tags, and in its
						original packaging. You’ll also need the receipt or proof of
						purchase.
					</p>
					<p>
						To initiate a return, please contact us at {email}. Returns must be
						sent to a designated address provided by us. If your return is
						approved, we will provide you with a return shipping label along
						with instructions on how and where to send your package. Please note
						that items sent back without prior approval will not be accepted.
					</p>
					<p>
						You can always contact us for any return question at
						{email}.
					</p>
				</section>

				<section className="terms-section">
					<h2>Damages and issues</h2>
					<p>
						Please inspect your order upon reception and contact us immediately
						if the item is defective, damaged or if you receive the wrong item,
						so that we can evaluate the issue and make it right.
					</p>
				</section>
				<section className="terms-section">
					<h2>Exceptions / non-returnable items</h2>
					<p>Unfortunately, we cannot accept returns on sale items.</p>
				</section>
				<section className="terms-section">
					<h2>Exchanges</h2>
					<p>
						The fastest way to ensure you get what you want is to return the
						item you have, and once the return is accepted, make a separate
						purchase for the new item.
					</p>
				</section>
				<section className="terms-section">
					<h2>Refund</h2>
					<p>
						We will notify you once we’ve received and inspected your return,
						and let you know if the refund was approved or not. If approved,
						you’ll be automatically refunded on your original payment method
						within 14 business days. Please remember it can take some time for
						your bank or credit card company to process and post the refund too.
						If more than 20 business days have passed since we’ve approved your
						return, please contact us at {email}
					</p>
				</section>
			</div>

			<footer className="terms-footer">
				<p>
					© {new Date().getFullYear()} {businessName}. All Rights Reserved.
				</p>
			</footer>
		</div>
	);
};

export default RefundPolicy;
